import { render, staticRenderFns } from "./RolesPanel.vue?vue&type=template&id=1c3f7c8b&"
import script from "./RolesPanel.vue?vue&type=script&lang=ts&"
export * from "./RolesPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports